// src/lib/useDpcLabels.ts
// [絞り込み保持 2026-07-17] サイドバー DPC 階層チップ (手術分類/処置1分岐/処置2分岐) の名称解決。
// 行クリック経由なら表の行に名称があるが、URL 復元 (?d10=...) はコードしか持たないため、
// /api/query/dpc_labels でコード → dpchier 分岐名を逆引きする。
import { useQuery } from "@tanstack/react-query";
import type { DpcLabelsResponse } from "@shared/api";
import { GP_MODE_HEADER } from "./gpMode";

export function useDpcLabels(
  d10: string | null,
  d11: string | null,
  d12: string | null,
) {
  const enabled = !!(d10 || d11 || d12);
  return useQuery({
    queryKey: ["dpc_labels", d10, d11, d12],
    queryFn: async () => {
      const p = new URLSearchParams();
      if (d10) p.set("d10", d10);
      if (d11) p.set("d11", d11);
      if (d12) p.set("d12", d12);
      const r = await fetch(`/api/query/dpc_labels?${p.toString()}`, { credentials: "include", headers: { ...GP_MODE_HEADER } });
      if (!r.ok) throw new Error(`dpc_labels ${r.status}`);
      return r.json() as Promise<DpcLabelsResponse>;
    },
    enabled,
    placeholderData: (prev) => prev,
    staleTime: 5 * 60_000,
  });
}
